import React, { forwardRef } from "react";

import classnames from "classnames";

import { StyledTag, StyledTagText, StyledTagDot } from "./Styles";

export interface TagProps {
  name: string;
  color: string;
  showText?: boolean;
  showDot?: boolean;
  className?: string;
}

export const Tag = forwardRef<
  HTMLDivElement,
  TagProps & Omit<React.ComponentPropsWithoutRef<"div">, keyof TagProps>
>(
  (
    { name, color, showText = true, showDot = true, className, ...rest },
    ref
  ) => {
    return (
      <StyledTag className={classnames("c-tag", className)} ref={ref} {...rest}>
        {showDot ? <StyledTagDot $showText={showText} color={color} /> : null}
        {showText ? <StyledTagText color={color}>{name}</StyledTagText> : null}
      </StyledTag>
    );
  }
);

Tag.displayName = "Tag";
